import { TimePanelSettingStore, PanelView } from './schema/TimePanelSettingsStore';
import { createStore } from 'satcheljs';
import { createNavigationStack } from 'owa-navigation-stack';
import { getOwaWorkload, OwaWorkload } from 'owa-workloads';

export const getStore = createStore<TimePanelSettingStore>('timePanelSettingStore', {
    panelViewStack: createNavigationStack<PanelView>(getInitialPanelView()),
});

export function getInitialPanelView(): PanelView {
    return getOwaWorkload() !== OwaWorkload.Calendar ? 'Calendar' : 'Tasks';
}
